import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import ReportsViewerSlideInnerComponent from 'webapp/components/reports/viewer/slide-inner';

export default class ReportsEditorSlideInnerComponent extends ReportsViewerSlideInnerComponent {
	topbarHeight = 60; // slide editor topbar
	paddingSize = 14; // padding left, right, bottom

	override updateInnerWidth(): void {
		const ct = $('.report_slide_ct');

		if (!ct.length) {
			return;
		}

		// calculating size for the inner part 16:9
		const availableWidth = ct.width()! - 2 * this.paddingSize - 20,
			availableHeight = ct.height()! - this.topbarHeight - this.paddingSize - 20,
			widthForAvailableHeight = (availableHeight * 16) / 9;

		const width = Math.min(availableWidth, widthForAvailableHeight);

		this.width = width;

		this.updateNodeStyle();

		this.triggerResizeForBlocks();
	}
	<template>
		<div
			class="report_slide_inner"
			style={{this.initialStyle}}
			{{didInsert this.setupInnerView}}
			{{willDestroy this.teardownInnerView}}
		>
			{{yield}}
		</div>
	</template>
}
